/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  signal,
  forwardRef,
  inject,
  Injector,
  runInInjectionContext, OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { OverlayContainer } from '@angular/cdk/overlay';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NgControl,
  AbstractControl,
} from '@angular/forms';
import { Icon } from '../icon/icon';

@Component({
  selector: 'srp-search-select',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatInputModule, Icon],
  templateUrl: './search-select.html',
  styleUrl: './search-select.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchSelect),
      multi: true,
    },
  ],
})
export class SearchSelect implements ControlValueAccessor, OnInit {

  @Input() defaultlabel:string;
  @Input() control:AbstractControl;
  @Input() appearance: 'fill' | 'outline' = 'fill';
  @Input() variant = '';
  @Input() options: any[] = [];
  @Input() isObject = false;
  @Input() valueProp = 'id';
  @Input() displayProp = 'name';
  @Input() countryName:string;
  localOptions = signal<any[]>([]);
  isPanelOpen = signal(false);
 constructor(
   private readonly overlayContainer: OverlayContainer
 ){};

  private readonly _disabled = signal(false);
  component: { set: jest.Mock<any, any, any>; };
  @Input() set disabled(val: boolean) {
    this._disabled.set(val);
  }
  disabledSignal = this._disabled;

  private readonly _value = signal<any>(null);
  value = this._value;
  isoCode:string;

  // control: AbstractControl | null = null;
  private readonly injector = inject(Injector);

  @Output() selectedValue = new EventEmitter<any>();

  ngOnInit(): void {
     this.overlayContainer.getContainerElement().classList.add('srp-search-menu');
    this._value.set(this.defaultlabel);
    this.localOptions.set(this.options);

    // Delay NgControl injection to avoid circular DI graph
    runInInjectionContext(this.injector, () => {
      const ngControl = inject(NgControl, { optional: true });
      this.control = ngControl?.control ?? null;
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  private onChange = (_: any) => {
    this.selectedValue.emit(_);
    this.defaultlabel=null;
   };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onTouched = () => { };

  writeValue(val: any): void {
    this._value.set(val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled.set(isDisabled);
  }

  onChangeHandler(val: any): void {
    this._value.set(val);
    this.onChange(val);
  }

  onBlur(): void {
    this.onTouched();
  }

  getValue(item: any): any {
        this.isoCode=item.isoCode;

    return this.isObject ? item[this.valueProp] : item;
  }

  getDisplay(item: any): string {
    return this.isObject ? item[this.displayProp] : item;
  }

  getErrorMessage(): string {
    if (!this.control?.errors) return '';
    if (this.control.hasError('required')) return 'Date is required';
    return 'Invalid selection';
  }

  search(value: string) {
    const filtered = this.options.filter((option) => {
      return option[this.displayProp].toLowerCase().startsWith(value.toLowerCase())
    }
    );
    if (filtered.length == 0) {
      return [{[this.valueProp]:'__not_found__',[this.displayProp]:'Not Found',disabled:true}];
    }
    return filtered;
  }

  onKey(eventTarget: any) {
    this.localOptions.set(this.search(eventTarget.value));
  }

  getSelectedOption() {
    const currentValue = this.value();
    return this.localOptions().find(item => this.getValue(item) === currentValue);
  }
}
